import { render, staticRenderFns } from "./FormCurrency.vue?vue&type=template&id=04b6d3ed&scoped=true"
import script from "./FormCurrency.vue?vue&type=script&lang=js"
export * from "./FormCurrency.vue?vue&type=script&lang=js"
import style0 from "./FormCurrency.vue?vue&type=style&index=0&id=04b6d3ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6d3ed",
  null
  
)

export default component.exports